import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import RoleBasedRedirect, { RequirePanelRoute } from './components/RoleBasedRedirect';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import NewsManagement from './pages/NewsManagement';
import EventsManagement from './pages/EventsManagement';
import ReportsManagement from './pages/ReportsManagement';
import AttractionsManagement from './pages/AttractionsManagement';
import WasteScheduleManagement from './pages/WasteScheduleManagement';
import SegregacjaManagement from './pages/SegregacjaManagement';
import AppSettings from './pages/AppSettings';
import PushNotifications from './pages/PushNotifications';
import ContactManagement from './pages/ContactManagement';
import UserManagement from './pages/UserManagement';
import StatusChangeRequests from './pages/StatusChangeRequests';
import PlacesManagement from './pages/PlacesManagement';
import CategoriesManagement from './pages/CategoriesManagement';
import Manage from './pages/Manage';
import AuditLog from './pages/AuditLog';
import VisitCounts from './pages/VisitCounts';
import ChatAssistantManagement from './pages/ChatAssistantManagement';
import AlarmSystemsManagement from './pages/AlarmSystemsManagement';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<RoleBasedRedirect />} />
                    <Route path="/dashboard" element={<RequirePanelRoute path="/dashboard"><Dashboard /></RequirePanelRoute>} />
                    <Route path="/news" element={<RequirePanelRoute path="/news"><NewsManagement /></RequirePanelRoute>} />
                    <Route path="/events" element={<RequirePanelRoute path="/events"><EventsManagement /></RequirePanelRoute>} />
                    <Route path="/reports" element={<RequirePanelRoute path="/reports"><ReportsManagement /></RequirePanelRoute>} />
                    <Route path="/attractions" element={<RequirePanelRoute path="/attractions"><AttractionsManagement /></RequirePanelRoute>} />
                    <Route path="/waste-schedule" element={<RequirePanelRoute path="/waste-schedule"><WasteScheduleManagement /></RequirePanelRoute>} />
                    <Route path="/segregacja" element={<RequirePanelRoute path="/segregacja"><SegregacjaManagement /></RequirePanelRoute>} />
                    <Route path="/app-settings" element={<RequirePanelRoute path="/app-settings"><AppSettings /></RequirePanelRoute>} />
                    <Route path="/push-notifications" element={<RequirePanelRoute path="/push-notifications"><PushNotifications /></RequirePanelRoute>} />
                    <Route path="/contact" element={<RequirePanelRoute path="/contact"><ContactManagement /></RequirePanelRoute>} />
                    <Route path="/alarm-systems" element={<RequirePanelRoute path="/alarm-systems"><AlarmSystemsManagement /></RequirePanelRoute>} />
                    <Route
                      path="/chat-assistant"
                      element={
                        <RequirePanelRoute path="/chat-assistant">
                          <ChatAssistantManagement />
                        </RequirePanelRoute>
                      }
                    />
                    <Route path="/users" element={<RequirePanelRoute path="/users"><UserManagement /></RequirePanelRoute>} />
                    <Route path="/status-requests" element={<RequirePanelRoute path="/status-requests"><StatusChangeRequests /></RequirePanelRoute>} />
                    <Route path="/interactive-map/places" element={<RequirePanelRoute path="/interactive-map/places"><PlacesManagement /></RequirePanelRoute>} />
                    <Route path="/interactive-map/categories" element={<RequirePanelRoute path="/interactive-map/categories"><CategoriesManagement /></RequirePanelRoute>} />
                    <Route path="/manage" element={<RequirePanelRoute path="/manage"><Manage /></RequirePanelRoute>} />
                    <Route path="/tabs" element={<Navigate to="/manage" replace />} />
                    <Route path="/audit-log" element={<RequirePanelRoute path="/audit-log"><AuditLog /></RequirePanelRoute>} />
                    <Route path="/visit-counts" element={<RequirePanelRoute path="/visit-counts"><VisitCounts /></RequirePanelRoute>} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster position="top-right" />
      </Router>
    </AuthProvider>
  );
}

export default App;
